import calls from '@/backend/api-calls'

const state = () => ({
  storage: null,
  selected: [],
  allSelected: false,
  loading: false,
  firstLoad: true
})

// getters
const getters = {
  ids: state => {
    return state.storage.storage_units.map(d => d.id);
  }
}

// actions
const actions = {
  getStorage: ({commit}, storageId) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.storage.get(storageId)
        .then(resp => {
          commit("setStorage", resp.data);
          commit("setLoading", false);
          commit("setFirstLoad", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  updateStorage: ({commit}, { storageId, data }) => {
    return new Promise((resolve, reject) => {
      calls.storage.put(storageId, data).then(
        resp => {
          commit("setStorage", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Storage successfully updated'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  addStorageUnit: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.storageUnits.post(data)
        .then(resp => {
          commit("insertStorageUnit", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteStorageUnit: ({commit}, storageUnitId) => {
    return new Promise((resolve, reject) => {
      calls.storageUnits.delete(storageUnitId)
        .then(resp => {
          commit("removeStorageUnit", storageUnitId);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setFirstLoad(state, status) {
    state.firstLoad = status;
  },
  setStorage(state, data) {
    state.storage = data;
  },
  insertStorageUnit(state, storageUnit) {
    state.storage.storage_units.push(storageUnit);
  },
  removeStorageUnit(state, storageUnitId) {
    state.storage.storage_units.forEach((storageUnit, i) => {
      if (storageUnit.id == storageUnitId) {
        state.storage.storage_units.splice(i, 1);
      }
    })
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}